import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeParser } from '../tree-parser.service';
import { TreeItem } from '../tree-item.interface';
import { Expanding } from '../../shared/animations/expanding';
import { Logger } from '../../development/logger.service';


interface TreeItemNode {
  data: TreeItem;
  level: number;
  expandable: boolean;
}

@Component({
  selector: 'bm-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  animations: [Expanding],
})

export class TreeComponent implements OnInit, OnChanges {

  treeControl: FlatTreeControl<TreeItemNode>;
  treeFlattener: MatTreeFlattener<TreeItem, TreeItemNode>;
  dataSource: MatTreeFlatDataSource<TreeItem, TreeItemNode>;

  @Input() indent = 20;
  @Input() treeData: TreeItem[] = [];
  @Output() itemActivated = new EventEmitter<TreeItem>();


  constructor(private treeParser: TreeParser, private logger: Logger) {}

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.treeData.firstChange) {
      this.dataSource.data = this.treeParser.parse(this.treeData);
    }
  }

  ngOnInit() {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren,
    );

    this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener, []);
  }

  activateItem(item: TreeItem) {
    this.itemActivated.emit(item);
    this.logger.infoLog('Tree item activated', item);
  }

  transformer(node: TreeItem, level: number): TreeItemNode {
    return {
      data: node,
      level,
      expandable: node.children.length > 0,
    };
  }

  getLevel(node: TreeItemNode): number {
    return node.level;
  }

  isExpandable(node: TreeItemNode): boolean {
    return node.expandable;
  }

  getChildren(node: TreeItem): TreeItem[] {
    return node.children;
  }

  hasChild(index: number, node: TreeItemNode): boolean {
    return node.expandable;
  }
}
